export const convertFileTypeToIcon = (fileType: string) => {
  fileType = fileType.toLowerCase();
  if (fileType.startsWith("image/")) {
    return "material-icon-theme:image";
  }
  switch (fileType) {
    case "application/pdf":
    case "pdf":
      return "vscode-icons:file-type-pdf2";

    case "png":
    case "image/png":
      return "vscode-icons:file-type-image";

    case "docx":
    case "application/msword":
    case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      return "vscode-icons:file-type-word";

    case "xlsx":
    case "application/vnd.ms-excel":
    case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      return "vscode-icons:file-type-excel";

    case "pptx":
    case "application/vnd.ms-powerpoint":
    case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
      return "vscode-icons:file-type-powerpoint";
    default:
      return "material-icon-theme:document";
  }
};
